module.exports = {"TXTWCL_Resend_in_N0":{"id":"TXTWCL_Resend_in_N0","defaultMessage":"再送信する (あと {0} 後)"}}